import { CommonModule, DOCUMENT } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { environment } from '../../../../environments/environment';
import { DropdownModule } from 'primeng/dropdown';
import { StartupProfileService } from '../../../modules/panel/_services/startup-profile.service';
import { TooltipModule } from 'primeng/tooltip';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-startup-profile-haeder',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    TranslateModule,
    OverlayPanelModule,
    DropdownModule,
    TooltipModule
  ],
  templateUrl: './startup-profile-haeder.component.html',
  styleUrl: './startup-profile-haeder.component.scss'
})
export class StartupPprofileHaederComponent implements OnInit {
  fileServerUrl = environment.fileServerUrl;
  profiles = [];
  profile: any;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    startupProfileService: StartupProfileService,
    @Inject(DOCUMENT) private document: Document
  ) {
    startupProfileService.getUserProfiles().subscribe(x => {
      this.profiles = x;
      if (x?.length) {
        this.profile = route.snapshot.queryParams['startupid'] ? +route.snapshot.queryParams['startupid'] : x[0].id;
        this.router.navigate([], { queryParams: { startupid: this.profile }, relativeTo: this.route, preserveFragment: true });
      }
      if (x?.length > 1) {
        document.body.classList.add('has-startup-profile');
      } else {
        document.body.classList.remove('has-startup-profile');
      }
    })
  }

  ngOnInit(): void { }

  onChange() {
    if (this.profile)
      this.router.navigate([], { queryParams: { startupid: this.profile }, relativeTo: this.route, preserveFragment: true });
  }
}
